import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ShippingInfo extends HTMLElement {
    connectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.addEventListener(ThemeEvents.variantUpdate, this.shippingUpdate);
    }

    disconnectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.removeEventListener(ThemeEvents.variantUpdate, this.shippingUpdate);
    }

    /**
     * Updates the shipping info.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    shippingUpdate = (event) => {
        console.log(event.detail.data.newProduct)
        if (event.detail.data.newProduct) {
            this.dataset.productId = event.detail.data.newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
            return;
        }

        const newShippingInfo = event.detail.data.html.querySelector('shipping-info [ref="shippingContainer"]');
        const currentShippingInfo = this.querySelector('[ref="shippingContainer"]');

        if (!newShippingInfo || !currentShippingInfo) return;

        if (currentShippingInfo.innerHTML !== newShippingInfo.innerHTML) {
            currentShippingInfo.replaceWith(newShippingInfo);
        }
    };
}
if (!customElements.get('shipping-info')) {
    customElements.define('shipping-info', ShippingInfo);
}
